import React from 'react';
import Label from 'js/containers/Pages/Search/SearchResults/Entities/components/Label/Label';
import {EntitiesTypesDataInterface} from 'js/containers/Pages/Search/SearchResults/Entities/EntitiesTypesDataInterface';

import classes from './ExpandableSection.module.pcss';
import ExpandableSectionHeading from './ExpandableSectionHeading';
import ExpandableSectionInfo from './ExpandableSectionInfo';


interface Props {
    title: string,
    info: string | JSX.Element | JSX.Element[],
    nodeRef: any,
    withoutLine?: boolean,
    withTypeLabel?: boolean,
    isOpened?: boolean,
    withStatus?: boolean,
    insideEl?: any,
    postId?: number,
    id?: string,
    beforeCompletedMessage?: string,
    showBeforeCompleteMessage?: boolean,
    entityType?: EntitiesTypesDataInterface,
    additionalHandlerCallback?: Function,
    statusCallback?: Function,
    isStatusChecked?: boolean
}

const ExpandableSection = (
    {
        title,
        info,
        postId = null,
        isOpened = false,
        withTypeLabel = false,
        entityType = 'articles',
        nodeRef,
        insideEl = '',
        isStatusChecked = false,
        withoutLine = false,
        beforeCompletedMessage = '',
        showBeforeCompleteMessage = false,
        additionalHandlerCallback = () => {},
        withStatus = false,
        statusCallback = () => {},
        id = ''
    }: Props) => (
    <section className={`${classes.ExpandableSection} ${withoutLine ? classes.WithoutLine : ''}`}>
        <ExpandableSectionHeading
            text={title}
            id={id}
            postId={postId}
            insideEl={insideEl}
            nodeRef={nodeRef}
            isOpened={isOpened}
            withStatus={withStatus}
            withTypeLabel={withTypeLabel}
            statusCallback={statusCallback}
            isStatusChecked={isStatusChecked}
            showBeforeCompleteMessage={showBeforeCompleteMessage}
            beforeCompletedMessage={beforeCompletedMessage}
            additionalHandlerCallback={e => additionalHandlerCallback(e)}
        />
        {withTypeLabel ? <Label additionalStyles={{marginRight: '10px'}} type={entityType} /> : ''}
        <ExpandableSectionInfo data={info} isOpened={isOpened}/>
    </section>
);

export default ExpandableSection;
